import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { OperationProcess } from '../operation-process';
import { mapCollection, sortByString } from '../../utils/collection.utils';
import { PathBuilder } from './path.builder';

export class OperationProcessBuilder {
  static fromJson(json) {
    return (json)
      ? new OperationProcess(
        json.hash,
        parseNumber(json.sequenceCode),
        json.operationCode,
        parseNumber(json.pieceQuantity),
        parseNumber(json.prevPreparationTime),
        parseNumber(json.prevExecutionTime),
        json.description,
        json.programReference,
        json.processCode,
        json.gamaCode,
        PathBuilder.fromList(json.paths),
        json.operationType
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? sortByString('description', mapCollection(OperationProcessBuilder.fromJson, list)) : [];
  }

  static fromListByCode(list) {
    return (isArray(list)) ? sortByString('operationCode', mapCollection(OperationProcessBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/operation-process.builder.ts